import * as React from 'react';
import { cn } from '../../utils/cn';

export const SelectOverlay = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-modalBackdrop bg-black/50',
            className,
        )}
        aria-hidden="true"
        data-testid="Backdrop"
        {...props}
    />
));

SelectOverlay.displayName = 'SelectOverlay';
